import { createFileRoute, redirect } from '@tanstack/react-router';

// Landing after login: Shipments (07 §1).
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/shipments' });
  },
});
